import type { WorkQueueProjection } from "./types";

export type QueueErrorKind = "unauthorized" | "generic";

export type QueueFetchOutcome =
  | { kind: "ok"; projection: WorkQueueProjection }
  | { kind: "missing" }
  | { kind: "unauthorized"; message: string }
  | { kind: "error"; message: string };

function readErrorMessage(body: unknown, fallback: string): string {
  if (!body || typeof body !== "object") return fallback;
  const rec = body as { detail?: unknown; error?: unknown };
  if (typeof rec.detail === "string" && rec.detail.trim()) return rec.detail;
  if (typeof rec.error === "string" && rec.error.trim()) return rec.error;
  return fallback;
}

/**
 * Map work-queue HTTP to UI state. Never invent bucket membership on missing/403.
 */
export function interpretQueueHttp(
  status: number,
  body: unknown,
): QueueFetchOutcome {
  if (status === 401 || status === 403) {
    return {
      kind: "unauthorized",
      message: readErrorMessage(body, "ไม่มีสิทธิ์ดูคิวงานเงินนี้"),
    };
  }
  if (status === 404) {
    return { kind: "missing" };
  }
  if (status < 200 || status >= 300) {
    return {
      kind: "error",
      message: readErrorMessage(body, `โหลดคิวงานเงินไม่สำเร็จ (${status})`),
    };
  }
  const projection = body as WorkQueueProjection;
  if (
    projection?.serverProjectionMissing ||
    projection?.freshness === "unavailable"
  ) {
    return { kind: "missing" };
  }
  return { kind: "ok", projection };
}

export function missingQueueProjection(): WorkQueueProjection {
  return {
    projectionRevision: 0,
    freshness: "unavailable",
    serverProjectionMissing: true,
    buckets: [],
  };
}
